/**
 * Native <dialog> open/close (search, newsletter, etc.).
 *
 * @param {Object} options
 * @param {HTMLDialogElement|null} options.dialog
 * @param {string} options.openSelector
 * @param {string} options.closeSelector
 * @param {string} [options.focusSelector]
 * @param {() => void} [options.onBeforeOpen]
 */
export const initDialog = ({
  dialog,
  openSelector,
  closeSelector,
  focusSelector,
  onBeforeOpen,
}) => {
  if (!dialog || typeof dialog.showModal !== 'function') {
    return
  }

  const openTriggers = document.querySelectorAll(openSelector)
  const closeTriggers = document.querySelectorAll(closeSelector)

  const handleOpen = () => {
    if (onBeforeOpen) {
      onBeforeOpen()
    }

    dialog.showModal()

    if (focusSelector) {
      const focusTarget = dialog.querySelector(focusSelector)

      if (focusTarget) {
        focusTarget.focus()
      }
    }
  }

  const handleClose = () => {
    dialog.close()
  }

  openTriggers.forEach((trigger) => {
    trigger.addEventListener('click', handleOpen)
  })

  closeTriggers.forEach((trigger) => {
    trigger.addEventListener('click', handleClose)
  })

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
      handleClose()
    }
  })

  dialog.addEventListener('cancel', handleClose)
}
